import React from 'react';
import { motion } from 'framer-motion';
export function MidPageCTA() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8
  }} className="my-20 text-center space-y-6" data-id="element-146">
      <p className="text-xl md:text-2xl font-bold text-[#1B2A4A]" data-id="element-147">
        Ready to fix this?
      </p>

      <div className="flex items-center justify-center gap-2 mb-2" data-id="element-148">
        <span className="text-base text-[#1B2A4A]/50 line-through font-sans" data-id="element-149">
          $29
        </span>
        <span className="bg-[#D4652A] text-white text-xs font-bold px-2 py-0.5 rounded font-sans" data-id="element-150">
          78% OFF
        </span>
      </div>

      <button onClick={() => document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    })} className="inline-flex items-center justify-center px-6 py-3 text-base md:text-lg font-bold text-white transition-all duration-200 bg-[#D4652A] rounded-md shadow-md hover:shadow-lg hover:scale-[1.02] hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4652A] font-sans" data-id="element-151">
        GET THE RESCUE KIT — $6.36
      </button>

      <p className="text-sm text-[#1B2A4A]/50 uppercase tracking-wide" data-id="element-152">
        Keep reading if you want to see exactly what&apos;s inside.
      </p>
    </motion.section>;
}